import { createFileRoute } from '@tanstack/react-router';
import { CustoFabricaPage, lerBuscaCustoFabrica, mesAtual } from '@/components/plano';

export const Route = createFileRoute('/_app/plano/custo-fabrica')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaCustoFabrica(bruto),
  component: CustoFabricaRota,
});

function CustoFabricaRota() {
  const busca = Route.useSearch();
  return <CustoFabricaPage mes={busca.mes ?? mesAtual()} />;
}
